<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCSpecs :h2="h2" :h3="h3" :specs="specs" style="white-space:nowrap;" />
  </div>
</template>

<script>
import FCSpecs from "@/components/patterns/FCSpecs";
export default {
  components: {
    FCSpecs,
  },
  mounted() {
    const ref = this.$store.state.menu.reservedSeating.ref;
    const index = this.$store.state.menu.menuItems
      .map((e) => e.ref)
      .indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.reservedSeating.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.reservedSeating.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Reserved Seating",
      h3: "Specs",
      specs: [
        {
          icon: "chair.svg",
          text: `No seat further than 130 feet from the field`,
        },
        {
          icon: "drink.svg",
          text: `Chairback seats with cupholders`,
        },
        {
          icon: "icon-canopy.svg",
          text: `Covered by canopy roof`,
        },
        {
          icon: "icon-sightlines.svg",
          text: `Unprecedented sightlines`,
        },
        {
          icon: "icon-proximity.svg",
          text: `Proximity to field`,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-reservedseating.jpg");
  background-size: cover;
  background-position: center;
}
</style>